import React, { MouseEventHandler } from 'react';

type TFullScreenButtonProps = {
    readonly onClick: MouseEventHandler<HTMLButtonElement>;
};

const FullScreenButton: React.FC<TFullScreenButtonProps> = ({ onClick }) => {
    return (
        <button
            className='btn full-screen-btn absolute flex items-center justify-center rounded p-0'
            aria-label='Full screen'
            onClick={onClick}
        ></button>
    );
};

export type { TFullScreenButtonProps };
export default FullScreenButton;
